<template>
  <div class='container' >
    <div class='row'>
      <div class='col-md-8 offset-md-2 mt-5'>
        <div class='card p-2 contact1' style='margin-top: 10vh'>
        <div class='row'>
          <div class='col-md-8 contact2'>
            <form @submit.prevent='registerUser'>
            <div class='form-group'>
              <label for='name'>Name</label>
              <input placeholder="Enter your name@."
               required
                v-model='user.name'
                type='text'
                class='form-control'
                id='name'
              />
            </div>
            <div class='form-group'>
              <label for='email'>Email address</label>
              <input placeholder='Enter your e-mail@.'
                required
                v-model='user.email'
                type='email'
                class='form-control'
                id='email'
              />
            </div>
            <div class='form-group'>
              <label for='phone'>Message</label>
              <textarea style='height:20vh' placeholder='Type your message here@.'
                required
                v-model='user.message'
                class='form-control'
                id='message'
              ></textarea>
            </div>
            <div class='form-group'>
                <button class='btn btn-success' type='submit'>
                                Submit
            </button>
            </div>
              <!-- <span v-if='loader' class='spinner-border spinner-border-sm' role='status'
                                        aria-hidden='true'></span> -->
          </form></div>
          <div class='col-md-4 contact3'>
            <div class='contactTitle'>
              <p >CONTACT </p>
              <p>US</p>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      user: {
        name: '',
        email: '',
        message: ''
      },
      errors: {}
    }
  },
  //   methods: {
  //     submit() {
  //       this.errors = {};
  //       axios.post('/submit', this.user).then(response => {
  //         alert('Message sent!');
  //       }).catch(error => {
  //         if (error.response.status === 422) {
  //           this.errors = error.response.data.errors || {};
  //         }
  //       });
  //     },
  methods: {
    async registerUser () {
      // this.loader = true

      try {
        // debugger;
        let response = await axios.post(
          'https://www.natourmontenegro.com:8081/user',
          this.user
        )

        console.log(response)
        alert('Your message has been sent.')
        // this.loader = false;
      } catch (err) {
        console.log('error:' + err)
        alert('Something Went Wrong')
        // this.loader = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue